import {Icon,type IconName} from './Icon';
import { toneForStatus } from './status-tone';

export const STATUS_BADGE_TONES = [
  'neutral',
  'information',
  'success',
  'warning',
  'danger',
  'unavailable',
] as const;

export type StatusBadgeTone = (typeof STATUS_BADGE_TONES)[number];

export type StatusBadgeProps = Readonly<{
  text: string;
  /** Omit to derive the tone from the status text with the single tone map. */
  tone?: StatusBadgeTone;
}>;

const toneLabels: Record<StatusBadgeTone, string> = {
  neutral: 'Status',
  information: 'Information',
  success: 'Successful status',
  warning: 'Needs attention',
  danger: 'Urgent attention',
  unavailable: 'Unavailable status',
};

const toneSymbols: Record<StatusBadgeTone, IconName> = {
  neutral: 'circle-minus',
  information: 'info',
  success: 'circle-check',
  warning: 'triangle-alert',
  danger: 'circle-alert',
  unavailable: 'circle-question-mark',
};

export function StatusBadge({ text, tone: requestedTone }: StatusBadgeProps) {
  const unknown=/^\s*(unknown|unverified|not recorded|unavailable)\s*$/i.test(text);
  const tone = unknown ? 'unavailable' : requestedTone ?? toneForStatus(text);
  return <span className={`status-badge status-badge--${tone}`} data-tone={tone} data-unknown={unknown||undefined}>
    <span className="status-badge__symbol" aria-hidden="true"><Icon name={toneSymbols[tone]}/></span>
    <span className="sr-only">{toneLabels[tone]}: </span>
    <span className="status-badge__text">{text}</span>
  </span>;
}
